import { render, staticRenderFns } from "./RolePage.vue?vue&type=template&id=4cb2673e&scoped=true&"
import script from "./RolePage.vue?vue&type=script&lang=js&"
export * from "./RolePage.vue?vue&type=script&lang=js&"
import style0 from "./RolePage.vue?vue&type=style&index=0&id=4cb2673e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2673e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb2673e')) {
      api.createRecord('4cb2673e', component.options)
    } else {
      api.reload('4cb2673e', component.options)
    }
    module.hot.accept("./RolePage.vue?vue&type=template&id=4cb2673e&scoped=true&", function () {
      api.rerender('4cb2673e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/RolePage.vue"
export default component.exports